import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { Organisation } from '../models/organisation';
import { Queries } from '../queries';

@Injectable({
  providedIn: 'root'
})
export class OrganisationsAdminService {

  constructor(private apollo: Apollo) { }

  getOrganisations(searchTerm: string = ''): Observable<Organisation[]> {
    return this.apollo.watchQuery<{organisations: Organisation[]}>({
      query: Queries.GET_ORGANISATIONS,
      variables: {
        searchTerm: searchTerm
      }
    }).valueChanges.pipe(map(result => result.data.organisations))
  }

  getOrganisation(organisationRef: string): Observable<Organisation> {
    return this.apollo.watchQuery<{organisation: Organisation}>({
      query: Queries.GET_ORGANISATION,
      variables: {
        organisationRef: organisationRef
      },
      // The available apps/roles are org-context-sensitive (the same app returns different role
      // sets per org), which can't be represented in Apollo's by-id normalized cache. Bypass it
      // so the raw per-org response is used instead of a merged/stale one.
      fetchPolicy: 'no-cache'
    }).valueChanges.pipe(map(result => result.data.organisation))
  }

}
